import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SingleStep } from './types';
import { SingleStepComponent } from './single-step/single-step.component';

@Component({
  selector: 'mbc-step-progress-tracker',
  templateUrl: './step-progress-tracker.component.html',
  styleUrls: ['./step-progress-tracker.component.scss'],
  imports: [CommonModule, SingleStepComponent],
})
export class StepProgressTrackerComponent {
  @Input() items: SingleStep[] = [];

  // Set the width of the single step dot.
  @Input() stepWidth = '8';

  // Set the height of the single step dot.
  @Input() stepHeight = '8';

  // Sets the active step.
  @Input() activeStep = 0;

  /**
   * Set the item to active in the items array based on the index that is provided.  Set the rest to inactive.
   * @param index The index of the item to set to active.
   */
  public setActiveItem(index: number): void {
    // Set all items to inactive.
    this.items.forEach((item) => (item.active = false));

    // Set the item at the index to active.
    this.items[index].active = true;
  }
}
